import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";

import { paths } from "../../data/paths";
import { Logo } from "../utility/logo/logo";
import { RouterLink } from "../utility/router-link";

const TOP_NAV_HEIGHT = 64;

const LayoutRoot = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "top center",
  backgroundImage: 'url("/assets/gradient-bg.svg")',
  display: "flex",
  flex: "1 1 auto",
  flexDirection: "column",
  height: "100%",
}));

export const Layout = (props) => {
  const { children } = props;

  return (
    <LayoutRoot>
      <Box
        component="header"
        sx={{
          left: 0,
          position: "relative",
          right: 0,
          top: 0,
          zIndex: (theme) => theme.zIndex.appBar,
        }}>
        <Container
          maxWidth="lg"
          className="logo_container"
          style={{ padding: "60px 0px" }}>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              height: TOP_NAV_HEIGHT,
              alignItems: "center",
              justifyContent: "center",
            }}>
            <Stack
              alignItems="center"
              component={RouterLink}
              direction="row"
              display="inline-flex"
              href={paths.index}
              spacing={1}
              sx={{ textDecoration: "none" }}>
              <Logo />
            </Stack>
          </Stack>
        </Container>
      </Box>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          flex: "1 1 auto",
        }}>
        <Container
          maxWidth="sm"
          sx={{
            pb: {
              xs: "20px",
              md: "90px",
            },
          }}>
          {children}
        </Container>
      </Box>
    </LayoutRoot>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
};
